<template>
  <div
    v-if="!hideFooter"
    class="z-[1000] w-full fixed bottom-0 left-0 bg-white border-t border-[#EBEBEB] px-6 py-4 flex items-center"
  >
    <div class="mx-auto max-w-[1200px] w-full flex justify-between items-center">
      <!-- Left: Back / Cancel button -->
      <div>
        <button
          v-if="hasPrev"
          class="flex items-center gap-2 px-4 py-2 text-sm text-neutral-600 hover:text-neutral-900 transition-colors"
          @click="$emit('back')"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {{ $t('common.back') }}
        </button>
        <button
          v-else
          class="flex items-center gap-2 px-4 py-2 text-sm text-neutral-600 hover:text-neutral-900 transition-colors"
          @click="$router.push({ name: 'dashboardRoot' })"
        >
          Cancel
        </button>
      </div>

      <!-- Right: Continue button -->
      <div v-if="!hideNext">
        <button
          :disabled="isNextDisabled"
          class="flex items-center gap-2 px-5 py-2 bg-[#10A14A] text-white text-sm rounded-lg hover:bg-[#0E8F42] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          @click="$emit('next')"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasPrev: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideNext: {
      type: Boolean,
      default: false,
    },
    isNextDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
